<template>
    <div style="position: relative; height: 200px;" class="w-100 w-100 lm-border pa-3">
        <c-flip-card
            v-model    ="flipped"
            class      = "w-100 tzb-gadget"
            :top       = "6"
            :right     = "0"
            color      = "primary--text"
            :enabled   = "!!zusInspection"
        >
            <template v-slot:front>
                <v-row class="no-frame w-100">
                    <f-title
                        :title="$t('unit.tzb.maintenance.title')"
                        class="w-100"
                    />
                </v-row>
                <v-row class="no-frame mt-n1">
                    <v-col class="no-frame pr-2">
                        <div class="tzb-title">
                            {{ $t('unit.tzb.maintenance.engineRoom') }}
                        </div>
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <c-site-tzb-rating
                            v-model="data.engineRoomRating"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-n1">
                    <v-col class="no-frame pr-2">
                        <div class="tzb-title">
                            {{ $t('unit.tzb.maintenance.manwhole') }}
                        </div>
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <c-site-tzb-rating
                            v-model="data.manwholeRating"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-n1">
                    <v-col class="no-frame pr-2">
                        <div class="tzb-title">
                            {{ $t('unit.tzb.maintenance.carRoof') }}
                        </div>
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <c-site-tzb-rating
                            v-model="data.carRoofRating"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-n1" >
                    <div class="w-100 mt-2" style="overflow-y: scroll; max-height:80px; font-size: 15px" v-if="readonly">
                        <div class="ma-0" v-html="htmlNote" >
                        </div>
                    </div>

                    <v-textarea
                        v-if="!readonly"
                        v-model="data.note"
                        class="pt-1"
                        rows="3"
                        no-resize
                    />
                </v-row>
            </template>
            <template v-slot:back>
                <v-row class="no-frame w-100">
                    <f-title
                        title="Wartungsnehmer und ZÜS aus Begehung"
                        class="w-100"
                    />
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        Wartungsnehmer
                    </v-col>
                    <v-col class="no-frame pr-2">
                       {{ data.mntCompany ? data.mntCompany.name : "---" }}
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        ZÜS
                    </v-col>
                    <v-col class="no-frame pr-2">
                        {{ zusInspection.zus ? zusInspection.zus.name : "---" }}
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        Nächste Prüfung
                    </v-col>
                    <v-col class="no-frame pr-2">
                        {{ zusInspection.nextMonth ? zusInspection.nextMonth : "---" }}  / {{ zusInspection.nextYear ? zusInspection.nextYear : "---" }}
                    </v-col>
                </v-row>
            </template>
        </c-flip-card>
    </div>
</template>

<script>

import FTitle         from "@/modules/core/components/utils/FTitle";
import CSiteTzbRating from "@/modules/msd/unit/components/dialog/CSiteTzbRating";
import CFlipCard from "@/modules/core/components/utils/CFlipCard.vue";

export default {
    name: "SiteTzbElevatorMaintenance",

    components: {
        CFlipCard,
        CSiteTzbRating,
        FTitle,
    },

    props: {
        data: {
            default: {
                engineRoomRating: null,
                manwholeRating  : null,
                carRoofRating   : null
            }
        },

        zusInspection: {

        },

        readonly: {

        }
    },

    data: () => ({
        flipped: false,
        edit : false,
    }),

    computed: {
        htmlNote () {
            if (!this.data.note) {
                return null;
            }

            return this.data.note.replaceAll ("\\n", "<br>");
        }
    },

    methods: {
        onEdit () {
            this.edit  = !this.edit;
        }
    }
}
</script>

<style scoped>

.tzb-title {
    font-size: 15px;
}

</style>